export default "__VITE_ASSET__BYcRr0mR__"